import { createFileRoute, Outlet, Link } from '@tanstack/react-router'

function SecurityLayout() {
  return (
    <div
      style={{
        fontFamily: 'var(--oe-font-sans)',
        background: '#FDF8F3',
        color: '#1a1216',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <header
        style={{
          maxWidth: 720,
          margin: '0 auto',
          width: '100%',
          padding: '32px 24px 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Link
          to="/"
          style={{
            fontFamily: 'var(--oe-font-mono)',
            fontWeight: 700,
            fontSize: 15,
            color: '#1a1216',
            textDecoration: 'none',
            letterSpacing: '-0.02em',
          }}
        >
          one-email
        </Link>
        <Link
          to="/"
          style={{
            fontSize: 13,
            color: '#777',
            textDecoration: 'none',
            fontWeight: 500,
          }}
        >
          &larr; Back to home
        </Link>
      </header>

      <main
        id="main-content"
        style={{
          maxWidth: 720,
          margin: '0 auto',
          width: '100%',
          padding: '48px 24px 80px',
          flex: 1,
        }}
      >
        <Outlet />
      </main>

      <footer
        style={{
          maxWidth: 720,
          margin: '0 auto',
          width: '100%',
          padding: '24px 24px 48px',
          borderTop: '1px solid #e8e0d8',
        }}
      >
        <p
          style={{
            fontSize: 13,
            color: '#999',
            fontWeight: 500,
          }}
        >
          &copy; {new Date().getFullYear()} One-Email. All rights reserved.
        </p>
      </footer>
    </div>
  )
}

export const Route = createFileRoute('/security')({
  component: SecurityLayout,
})
